import React from 'react';
import Services from '../../components/AdminNext/Services';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Services — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Services />
      </HeadLessLayout>
    )
  };
}

export default action;
